import React from 'react';
import {TourProvider} from './TourContext';
import {LogoProvider} from './CompanyLogoContext';
import {ColorProvider} from './CompanyColorContext';
import FilterContextProvider from './FilterContext';
import {CheckboxContextProvider} from './CheckboxContext';
import EasyOnboardContextProvider from './EasyOnboardContext';
import CreditCheckContextProvider from './CreditCheckContext';
import {EasyDetectContextProvider} from './EasyDetectContext';
import {AMLProvider} from './AMLContext';

const GlobalContextProvider = ({isAuthenticated, children}) => {
  if (isAuthenticated) {
    return (
      <AMLProvider>
        <CheckboxContextProvider>
          <FilterContextProvider>
            <EasyOnboardContextProvider>
              <EasyDetectContextProvider>
                <CreditCheckContextProvider>
                  {children}
                </CreditCheckContextProvider>
              </EasyDetectContextProvider>
            </EasyOnboardContextProvider>
          </FilterContextProvider>
        </CheckboxContextProvider>
      </AMLProvider>
    );
  }

  return (
    <ColorProvider>
      <LogoProvider>
        <TourProvider>
          <AMLProvider>
            <CheckboxContextProvider>
              <FilterContextProvider>
                <EasyOnboardContextProvider>
                  <EasyDetectContextProvider>
                    <CreditCheckContextProvider>
                      {children}
                    </CreditCheckContextProvider>
                  </EasyDetectContextProvider>
                </EasyOnboardContextProvider>
              </FilterContextProvider>
            </CheckboxContextProvider>
          </AMLProvider>
        </TourProvider>
      </LogoProvider>
    </ColorProvider>
  );
};

export default GlobalContextProvider;
